import type { GeneratedCapsuleKeys } from 'new/modules/settings/capsules/domain/capsule.types';
import type { CapsuleResponseWithKeys } from 'new/stores/capsules/capsules.endpoints';

/**
 * Maps POST /clusters success body to fields shown on the Copy Keys step.
 * Uses string values from the API response; missing fields map to empty strings.
 */
export function mapClusterCreateResponseToGeneratedKeys(
  dto: CapsuleResponseWithKeys,
): GeneratedCapsuleKeys {
  return {
    apiAccessKey: typeof dto.api_access_key === 'string' ? dto.api_access_key : '',
    registrationKey: typeof dto.registration_key === 'string' ? dto.registration_key : '',
  };
}
